import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';

/**
 * Configuration service configurations
 * These services are used by the configuration module
 */
export const configurationServices: ServiceConfig[] = [
  {
    name: 'configService',
    factory: () => new BaseService('/api/configuration'),
  },
  {
    name: 'userConfigService',
    factory: () => new BaseService('/api/configuration/users'),
  },
  {
    name: 'facilityConfigService',
    factory: () => new BaseService('/api/configuration/facilities'),
  },
  {
    name: 'systemConfigService',
    factory: () => new BaseService('/api/configuration/system'),
  },
];

/**
 * Configuration-specific service factory
 * Creates a custom service with configuration-specific configuration
 */
export const createConfigurationCustomService = (
  serviceName: string,
  baseUrl: string = '/api/configuration',
): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Configuration service utilities
 */
export const configurationServiceUtils = {
  /**
   * Get all configuration service names
   */
  getServiceNames: () => configurationServices.map(s => s.name),

  /**
   * Check if a service name is a configuration service
   */
  isConfigurationService: (name: string) => configurationServices.some(s => s.name === name),

  /**
   * Get configuration base path
   */
  getBasePath: () => '/securitization/configuration',
};
